import { render, staticRenderFns } from "./404.vue?vue&type=template&id=b91b8dd4&lang=pug&"
import script from "./404.vue?vue&type=script&lang=coffee&"
export * from "./404.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports